module.exports = __webpack_public_path__ + "img/icon_delete.6407a8f0.png";